module.exports = __webpack_public_path__ + "img/cta_bg.00ac2c57.png";